module.exports = "\r\nuniform sampler2D tDiffuse;\r\nuniform float u_amount;\r\nvarying vec2 f_uv;\r\n\r\n// tDiffuse is a special uniform sampler that THREE.js will bind the previously rendered frame to\r\n\r\nvoid main() {\r\n    vec4 col = texture2D(tDiffuse, f_uv);\r\n\r\n    col.rgb = vec3(1.0 - col[0], 1.0 - col[1], 1.0 - col[2]) * (u_amount) + col.rgb * (1.0 - u_amount);\r\n\r\n    gl_FragColor = col;\r\n}   "


//////////////////
// WEBPACK FOOTER
// ./src/glsl/invert-frag.glsl
// module id = 33
// module chunks = 0